/* 
 * © Copyright 2015
 * Landcare Research
 * 
 * Dual License with
 * 
 * GPL v3 - See http://www.gnu.org/licenses/gpl-3.0.txt
 * 
 * Any derivative work needs to be contributed back to this project
 * unless otherwise agreed with Landcare Research, New Zealand.
 */
export interface IActiveScope extends ng.IScope {
	isActive: Function;
}
export class ActiveCtrl {
	public static $inject = ['$scope', '$location'];

	constructor($scope: IActiveScope, $location: ng.ILocationService) {
		$scope.isActive = function(viewLocation) {
			//console.log('view location', viewLocation, $location.path());
			return viewLocation === $location.path();
		};
	}
}
